/** Po kliknięciu ikony verified na liście `/app/easy-estimate` — następne otwarcie kosztorysu z widoku oferty nada grant. */
export const EE_INTENT_VERIFIED_PAGE_KEY = 'ee-intent-verified-page';

/** Jednorazowe wejście na stronę zweryfikowanych dla danego `estimateId` (ustawiane przy nawigacji z oferty). */
export const EE_VERIFIED_GRANT_ESTIMATE_KEY = 'ee-verified-grant-estimate';

export function setIntentOpenVerifiedPositionsPage(): void {
  try {
    sessionStorage.setItem(EE_INTENT_VERIFIED_PAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearIntentOpenVerifiedPositionsPage(): void {
  try {
    sessionStorage.removeItem(EE_INTENT_VERIFIED_PAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function hasIntentOpenVerifiedPositionsPage(): boolean {
  try {
    return sessionStorage.getItem(EE_INTENT_VERIFIED_PAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function grantVerifiedPositionsPageForEstimate(estimateId: number): void {
  try {
    sessionStorage.setItem(EE_VERIFIED_GRANT_ESTIMATE_KEY, String(estimateId));
  } catch {
    /* ignore */
  }
}

/** Zapobiega fałszywemu odrzuceniu przy podwójnym mount (Strict Mode) po usunięciu klucza z sessionStorage. */
const verifiedGrantConsumedInMemory = new Set<string>();

/** Zwraca true przy ważnym wejściu (usuwa klucz z sessionStorage przy pierwszym sukcesie). */
export function consumeVerifiedPositionsPageGrant(estimateId: string): boolean {
  if (verifiedGrantConsumedInMemory.has(estimateId)) return true;
  try {
    const g = sessionStorage.getItem(EE_VERIFIED_GRANT_ESTIMATE_KEY);
    if (g === estimateId) {
      sessionStorage.removeItem(EE_VERIFIED_GRANT_ESTIMATE_KEY);
      verifiedGrantConsumedInMemory.add(estimateId);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
